import {FC, useEffect, useState} from "react";
import {humanSpaceState} from "../../helpers/humanSpaceState";
import {IGroup, RequestState} from "../../types/ApiTypes";

interface Props {
  space: IGroup
}

const SpaceDetailsStatus: FC<Props> = ({space}) => {
  const [spaceProgress, setSpaceProgress] = useState(0);

  useEffect(() => {
    setSpaceProgress(Math.round(50 * space.request_state));
    if(space.request_state === RequestState.Failed) setSpaceProgress(100);
  },[space.request_state])

  return (
    <>
      <h4 className='text-xl text-right'>Status: {humanSpaceState(space.request_state)}</h4>
      <div className="w-full bg-gray-700 rounded-full h-2.5 my-2">
        <div className={`${space.request_state === RequestState.Failed ? 'bg-error-default' : 'bg-primary'} h-2.5 rounded-full`} style={{
          width: `${spaceProgress}%`
        }}/>
      </div>
    </>
  );
};

export default SpaceDetailsStatus;